module.exports = __webpack_public_path__ + "assets/modeds_dark.2fe485ec.svg";